"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.HikansabumonChiefHyokaDetail = void 0;
var _TitleCard = _interopRequireDefault(require("01_core/components/layout/TitleCard"));
var _CButton = _interopRequireDefault(require("01_core/components/materials/CButton"));
var _CLabel = _interopRequireDefault(require("01_core/components/materials/CLabel"));
var _CallAPI = require("01_core/components/system/CallAPI");
var _APIs = require("01_core/constants/APIs");
var _CodeConsts = require("01_core/constants/CodeConsts");
var _labelConsts = require("01_core/constants/labelConsts");
var _openSSO = require("01_core/logics/openSSO");
var _react = _interopRequireDefault(require("react"));
var _reactIntl = require("react-intl");
var _reactRedux = require("react-redux");
var _material = require("@mui/material");
var _styles = require("@mui/material/styles");
var _KansaTgtJigyoBasicInfo = _interopRequireDefault(require("../../common/components/materials/KansaTgtJigyoBasicInfo"));
var _Consts = require("../../common/consts/Consts");
var _kansaResultActions = require("../kansaResultActions");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/**
 * 被監査部門責任者評価表示画面
 */
const StyledReturnButton = (0, _styles.styled)(_CButton.default)({
  margin: '0 0 0 auto'
});
const StyledLeftButton = (0, _styles.styled)(_CButton.default)(_ref => {
  let {
    theme
  } = _ref;
  return {
    marginRight: theme.spacing(2)
  };
});
const StyledComment = (0, _styles.styled)(_material.Typography)(_ref2 => {
  let {
    theme
  } = _ref2;
  return {
    whiteSpace: 'pre-line',
    fontSize: theme.typography.body2.fontSize
  };
});
class HikansabumonChiefHyokaDetail extends _react.default.Component {
  constructor(props) {
    super(props);
    /**
     * 子画面表示時処理
     */
    _defineProperty(this, "openWindowProcess", nextDispContent => {
      const params = {
        keyKansaTgtNendo: this.props.kansaInfo.kansaTgtNendo,
        keyKansaTgtJigyoId: this.props.kansaInfo.kansaTgtJigyoId,
        keyDispContent: nextDispContent
      };
      (0, _openSSO.openSubWindowWithParams)('kansa_result', _Consts.CONSTS.COMMON_SUB_WINDOW_KEY, '', '', params).focus();
    });
    this.state = {
      simpleFlg: ''
    };
    props.callAPI(_APIs.KANSA_TGT_JIGYO_BASIC, props.kansaInfo).then(response => {
      if (response.status === _APIs.STATUS.SUCCESS) {
        props.setKansaTgtJigyoBasicInfo(response.data);
        this.setState({
          simpleFlg: response.data.simpleFlg
        });
      }
    });
    props.callAPI(_APIs.HIKANSABUMON_CHIEF_HYOKA_DETAIL, props.kansaInfo).then(response => {
      if (response.status === _APIs.STATUS.SUCCESS && response.data) {
        props.setEntries(response.data);
      } else {
        props.setEntries([]);
      }
    });
  }
  componentDidMount() {
    window.scrollTo(0, 0);
  }
  render() {
    const {
      entries,
      intl,
      btnProps,
      kansaTgtJigyoBasicInfo
    } = this.props;

    // 戻るボタン
    const returnButton = /*#__PURE__*/_react.default.createElement(StyledReturnButton, {
      onClick: btnProps.onClick(false),
      autoWidth: true,
      negative: true
    }, btnProps.label);
    return /*#__PURE__*/_react.default.createElement(_TitleCard.default, {
      title: intl.formatMessage({
        id: _labelConsts.LABEL.KANSA_HIKANSA_HYOKA_DETAIL
      })
    }, /*#__PURE__*/_react.default.createElement(_material.CardActions, {
      sx: {
        display: 'flex',
        justifyContent: 'space-between'
      }
    }, /*#__PURE__*/_react.default.createElement(_material.Box, {
      sx: {
        display: 'flex',
        gap: 1
      }
    }, /*#__PURE__*/_react.default.createElement(StyledLeftButton, {
      onClick: this.state.simpleFlg === _CodeConsts.CODE.FLG_VALUE.CODE_0 ? () => this.openWindowProcess(_kansaResultActions.CONTENTS.RESULT_REFER_OLD) : () => this.openWindowProcess(_kansaResultActions.CONTENTS.RESULT_REFER)
    }, intl.formatMessage({
      id: _labelConsts.LABEL.KANSA_RESULT_DETAIL
    })), /*#__PURE__*/_react.default.createElement(StyledLeftButton, {
      onClick: this.state.simpleFlg === _CodeConsts.CODE.FLG_VALUE.CODE_0 ? () => this.openWindowProcess(_kansaResultActions.CONTENTS.SHITEKI_OLD_DETAIL) : () => this.openWindowProcess(_kansaResultActions.CONTENTS.SHITEKI_DETAIL)
    }, intl.formatMessage({
      id: _labelConsts.LABEL.KANSA_KAIZEN_PREVIEW
    }))), returnButton), /*#__PURE__*/_react.default.createElement(_material.CardContent, null, /*#__PURE__*/_react.default.createElement(_material.Grid, {
      container: true
    }, /*#__PURE__*/_react.default.createElement(_KansaTgtJigyoBasicInfo.default, {
      data: kansaTgtJigyoBasicInfo
    }), /*#__PURE__*/_react.default.createElement(_material.Grid, {
      size: {
        xs: 6
      }
    }, /*#__PURE__*/_react.default.createElement(_CLabel.default, {
      label: intl.formatMessage({
        id: _labelConsts.LABEL.KANSA_KINYU_DATE
      }),
      indent: true
    }, /*#__PURE__*/_react.default.createElement(_material.Typography, {
      variant: "body2"
    }, entries.kinyuDate)), /*#__PURE__*/_react.default.createElement(_CLabel.default, {
      label: intl.formatMessage({
        id: _labelConsts.LABEL.KANSA_KINYUSHA_NM
      }),
      indent: true
    }, /*#__PURE__*/_react.default.createElement(_material.Typography, {
      variant: "body2"
    }, entries.kinyushaNm)), /*#__PURE__*/_react.default.createElement(_CLabel.default, {
      label: intl.formatMessage({
        id: _labelConsts.LABEL.KANSA_COMMENT
      }),
      indent: true
    }, /*#__PURE__*/_react.default.createElement(StyledComment, null, entries.hikansabumonChiefComment))))), /*#__PURE__*/_react.default.createElement(_material.CardActions, null, returnButton));
  }
}
exports.HikansabumonChiefHyokaDetail = HikansabumonChiefHyokaDetail;
const mapStateToProps = state => {
  return {
    entries: state.kansaResult.entries,
    kansaInfo: state.kansaResult.kansaInfo,
    kansaTgtJigyoBasicInfo: state.kansaResult.kansaTgtJigyoBasicInfo
  };
};
const mapDispatchToProps = dispatch => {
  return {
    setEntries: entries => dispatch(_kansaResultActions.kansaResultActions[_kansaResultActions.TYPES.SET_ENTRIES](entries)),
    setContent: content => dispatch(_kansaResultActions.kansaResultActions[_kansaResultActions.TYPES.SET_CONTENT](content)),
    setKansaTgtJigyoBasicInfo: kansaTgtJigyoBasicInfo => dispatch(_kansaResultActions.kansaResultActions[_kansaResultActions.TYPES.SET_KANSA_TGT_JIGYO_BASIC_INFO](kansaTgtJigyoBasicInfo))
  };
};
var _default = exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)((0, _reactIntl.injectIntl)((0, _CallAPI.withCallAPI)(HikansabumonChiefHyokaDetail)));